exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dl-simulation-trace{padding-top:15px}.dl-simulation-trace dt{width:80px}.dl-simulation-trace dd{margin-left:100px;margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/web/simulator/SimulationTrace.css
// module id = 316
// module chunks = 0